// extracted by mini-css-extract-plugin
export var publicationPreview = "styles-module--publicationPreview--kK5hI";
export var price = "styles-module--price--FtMGH";
export var publicationImage = "styles-module--publicationImage--gy-6W";
export var logo = "styles-module--logo--Ci-K2";
export var ProductProPath = "styles-module--ProductProPath--PpR9f";
export var ProductItil = "styles-module--ProductItil--j9fvs";
export var ProductTransformation = "styles-module--ProductTransformation--zArL3";
export var ProductMaturity = "styles-module--ProductMaturity--5LdSn";
export var ProductResilia = "styles-module--ProductResilia--7Q-e1";